export enum ButtonTypeEnum {
  PRIMARY = 'primary',
  LINK = 'link',
}
